import pluralize from 'pluralize';

const handleFormErrors = (form, errors, errorKeys, response) => {
  form.errors = [];
  if (errorKeys.length > 0 && errors.constructor !== Array) {
    errorKeys.forEach((error) => {
      const field = form.fields.find(f => f.model === error);
      form.errors.push({ error: errors[error][0], field });
    });
  } else if (errors.constructor === Array && errors.length > 0) {
    errors.forEach((errorGroup, index) => {
      Object.keys(errorGroup).forEach((error) => {
        const field = form.fields.find(f => f.model === error);
        form.errors.push({ error: errors[index][error][0], field });
      });
    });
  } else if (response.status >= 400 && response.status < 500) {
    form.fields
      .filter(field => !field.type.toLowerCase().includes('submit'))
      .forEach(field => form.errors.push({ error: '', field }));
  }
  setTimeout(() => {
    window.scrollTo(0, document.querySelector('.form-group.error').offsetTop);
  }, 0);
};

export default {
  handleError({ commit, dispatch }, { response, form, fieldKey, showToastMessage }) {
    const showToast = showToastMessage === undefined ? true : showToastMessage;
    const errorResponse = (response && response.data ? response.data : response) || 'Cannot connect to API';

    const errors =
      errorResponse.errors || (errorResponse.data && errorResponse.data.errors ? errorResponse.data.errors : []);
    const errorKeys = Object.keys(errors);

    if (form) {
      const formErrors = fieldKey ? errors[fieldKey] : errors;
      handleFormErrors(form, formErrors, errorKeys, errorResponse);
    }

    /* eslint-disable no-console */
    if (errorKeys.length > 0) {
      console.error(errors);
    } else {
      console.error(errorResponse);
    }
    /* eslint-enable no-console */

    let messageText = errorResponse;
    if (errorResponse.message || errorResponse.errors) {
      messageText = form || errors.length === 0 ? errorResponse.message : Object.entries(errors)[0][1][0];
    }

    if (showToast) {
      dispatch('setMessage', {
        text: messageText || 'An unknown error occurred',
        messageType: 'error',
      });
    }
  },


  setMessage({ commit }, message) {
    commit('setMessage', message);
    window.setTimeout(() => commit('setMessage', { message: '', messageType: '' }), 5000);
  },

  loadResources({ commit, dispatch, state }, { to, resource }) {
    if (!to.name.startsWith('admin') && resource.adminOnly) return false;
    if (to.name.startsWith('admin') && resource.userOnly) return false;
    const prefix = to.name.startsWith('admin') ? 'admin/' : '';
    let key = to.params[resource.key];
    let dependsOn = to.params[resource.dependsOn];
    if (!/\D/.test(key)) key = parseInt(key);
    if (!/\D/.test(dependsOn)) dependsOn = parseInt(dependsOn);
    if ((key || dependsOn) && !resource.singleResource) {
      let fetchResources;
      if (resource.fetch !== false && state.user.sessionId) {
        if (resource.dependsOn) {
          fetchResources = dispatch(`${prefix}fetch${pluralize(resource.name)}`, dependsOn);
        } else {
          fetchResources = dispatch(`${prefix}fetch${pluralize(resource.name)}`);
        }
        if (to.params[resource.key] && !resource.noActiveResource) {
          fetchResources.then(() => commit(`${prefix}setActive${resource.name}`, key));
        }
      } else if (!resource.noActiveResource) {
        commit(`${prefix}setActive${resource.name}`, key);
      }
    } else if (resource.singleResource && key) {
      dispatch(`${prefix}fetch${resource.name}`, key);
    } else if (!resource.key) {
      dispatch(`${prefix}fetch${pluralize(resource.name)}`);
    } else if (!resource.noActiveResource) {
      commit(`${prefix}setActive${resource.name}`, 0);
    }
    return true;
  },

};
